module.exports = __webpack_public_path__ + "img/ring_y_0_1_1@3x.08d5c345.png";